/**
 * Function to get a random generated number to prevent caching, ready to be appended to the request.
 */
export function getCacheBuster(): string {
  return Math.random().toString().substring(2, 11)
}
